module.exports = __webpack_public_path__ + "media/images/lig/icon-clipboard-7a8ed586bdfc34b93721bb15b86325c7.svg";